import '@module/Favorite/_favorite.scss';
import '@sass/showresult/showresult.scss';
import { EventDispatcher, copyToClipboard, documentReady, gebi, isMobileView, l, lLink, logEvent, lreplace, qs, qsa, setUrlParameter, shareClick, toggleVisible } from '@utils/toolbox';
import { eventCategories, events } from '@js/utils/event';
import { Favorite } from '@js/components/favorite/favorite';
import { SearchBox } from '@module/SearchBox/SearchBox';
import { favouriteStatus } from '@js/components/resultsRenderHelpers';
import { resultsRender } from '@js/components/resultsRender';
import { toaster } from '@js/components/toast';


const { urlVars, timestamp, sharedOrgIndex } = js_params;
const defaultSorting = urlVars?.sorting || js_params.defaultSorting || 'bestValue';

const favoritePage = {
	mode: 'list',
	settingsModal: false,
	/**
 		* @type {Favorite}
 	*/
	favorite: false,
	elContainer: null,
	searchBoxWrapper: gebi('ab-showresult-search-box'),
	searchParams: {
		page: 0,
		id: urlVars.id,
		timestamp: timestamp,
		sorting: defaultSorting,
		filters: {},
		sharedOrgIndex: sharedOrgIndex,
		initial: true
	},
	/**
	 * Bind events and sets classes on the DOM
	 */
	init () {
		this.elContainer = qs('#favorite-table');
		this.createFavorite();
		this.initSearchBox();

		document.body.addEventListener('click', (ev) => {
			if (ev.target.closest('.mode')) {
				if (this.mode === 'table') {
					this.mode = 'list';
				} else if (this.mode === 'list') {
					this.mode = 'table';
				}
				qs('main').dataset.mode = this.mode;
				this.updateFavorite();
			}

			if (ev.target.closest('.share')) {
				if (ev.target.closest('.abBtn')) {
					shareClick({ title: js_params.domain_title, url: this.favorite.pageUrl }).catch((error) => {
						if (error.name === 'AbortError') {
							return;
						}
						copyToClipboard(this.favorite.pageUrl).then(() => {
							toaster.newToast(l('flightcompare.page.clipboard'), 'message', 'top');
						});
					});
				} else if (this.favorite.shareModeEnabled) {
					this.favorite.sharedModeToggle();
				} else {
					this.favorite.sharedListCreate();
				}

				logEvent(events.shareFavourites, eventCategories.feature);
			}

			if (ev.target.closest('.colRow.accordion')) {
				const rowid = ev.target.closest('.accordion').dataset.rowid;
				ev.target.closest('.accordion').classList.toggle('active');
				toggleVisible(qsa('[data-rowid=' + rowid + '] .colRow--inner'));
			}

			// Search box hide
			if (ev.target.closest('[data-action="hide-search-box"]') || (ev.target.classList.contains('abShowResultSearchBox__inner') && isMobileView())) {
				EventDispatcher.dispatch('searchBoxReset');
				this.hideSearchBoxExtended(200);
				return;
			}

			// Search box show
			if (ev.target.closest('[data-action="show-search-box"]')) {
				this.showSearchBoxExtended();
			}

			if (this.mode === 'list') {
				// Any tooltip
				if (ev.target.closest('.icon-circle-question-mark:not(.abIataTimespan__time--decoration--icon)')) {
					ev.stopPropagation();
					ev.preventDefault();

					if (ev.target.closest('.icon-circle-question-mark').parentElement.querySelector('.active')) {
						ev.target.closest('.icon-circle-question-mark').parentElement.querySelector('.question-mark--text').classList.remove('active');
					} else {
						ev.target.closest('.icon-circle-question-mark').parentElement.querySelector('.question-mark--text').classList.add('active');
					}

					return;
				}

				if (ev.target.closest('[data-action=refresh]')) {
					ev.stopImmediatePropagation();
					this.favorite.itemUpdateByIndex(ev.target.closest('.abResult').dataset.index, ev.target.closest('.abResult'));

					logEvent(events.refreshFavourite, eventCategories.feature);

					return;
				}

				if (ev.target.closest('[data-action=dismiss]')) {
					ev.stopImmediatePropagation();
					ev.target.closest('[data-action=dismiss]').style.display = 'none';
				}

				if (ev.target.closest('[data-action=delete]')) {
					ev.stopImmediatePropagation();
					this.favorite.itemRemoveByIndex(ev.target.closest('.abResult').dataset.index);

					logEvent(events.removeFavourite, eventCategories.feature);
				}
			} else if (this.mode === 'table') {
				if (ev.target.closest('[data-action=delete]')) {
					ev.stopImmediatePropagation();
					this.favorite.itemRemoveByIndex(ev.target.closest('.floating-col').dataset.index);

					logEvent(events.removeFavourite, eventCategories.feature);

					return;
				}

				if (ev.target.closest('[data-action=pin]')) {
					ev.stopImmediatePropagation();
					this.favorite.itemPinByIndex(Number(ev.target.closest('.floating-col').dataset.index));
					return;
				}

				if (ev.target.closest('[data-action=unpin]')) {
					ev.stopImmediatePropagation();
					this.favorite.itemPinByIndex();
					return;
				}

				if (ev.target.closest('[data-action=dismiss]')) {
					ev.stopImmediatePropagation();
					ev.target.closest('[data-action=dismiss]').style.display = 'none';
				}

				if (ev.target.closest('[data-action=refresh]')) {
					ev.stopImmediatePropagation();
					this.favorite.itemUpdateByIndex(ev.target.closest('.floating-col').dataset.index, ev.target.closest('.floating-col'));

					logEvent(events.refreshFavourite, eventCategories.feature);

					return;
				}


				if (ev.target.closest('.floating-col[data-status="old"]')) {
					this.favorite.itemUpdateByIndex(ev.target.closest('.floating-col').dataset.index, ev.target.closest('.floating-col'));
					return;
				}

				if (ev.target.closest('.floating-col:not([data-status=ancient])')) {
					const index = Number(ev.target.closest('.floating-col').dataset.index);
					const flight = resultsRender.response.flights[index];
					const className = favouriteStatus(flight) + ' modal--resultModal';
					resultsRender.renderModal(flight.favouriteMeta.responseId, flight, index, flight.favouriteMeta.filters, { className: className }, {}, 'favourites').open();

					logEvent(events.viewmoreResult, eventCategories.viewmore, resultsRender.response.flights[index]);
				}
			}
		});

		if (this.favorite.shareModeEnabled) {
			document.body.classList.add('share-mode');
			EventDispatcher.addEventListener('sharedFetched', (response) => {
				if (response.status && response.status !== 'ok') {
					this.favorite.renderHeader(l('fav.error.noflights'), '', l('fav.error.description'));
				} else {
					this.favorite.renderHeader(
						lreplace('fav.title.shared', { sharelistName: this.favorite.sharedNameGet() }),
						l('fav.title.description'),
						`<button class="abBtn abBtn--blueWhite share">${l('fav.ui.keepSharingBtn')} <span class="icon icon-share"></span></button>`
					);
				}
			});
		} else {
			const message = this.favorite.favouriteArray.length ? '' : l('flightcompare.page.addFlights');
			this.favorite.renderHeader(l('fav.ui.favTitle'), message);
		}
	},

	/**
	 * Initiatise favorite component
	 */
	createFavorite () {
		this.favorite = new Favorite(this.mode, '/' + lLink('global.navigation.favoriteLink'), this.elContainer);
	},

	/**
	 * Update favorite component with current mode and render
	 */
	updateFavorite () {
		this.favorite.mode = this.mode;
		this.favorite.render();
	},

	/**
	 * Initiatise searchbox component
	 */
	initSearchBox () {
		const searchboxConfig = {
			direct: 0,
			baggage: 0,
			cabinBaggage: 0,
			nearbyDates: 0,
			climateComp: 0,
			flexTicket: 0,
			legs: [
				{
					fromIatas: [
						{
							iata: '',
							isMetro: false,
							text: ''
						}
					],
					fromIata: '',
					from: '',
					toIatas: [
						{
							iata: '',
							isMetro: false,
							text: ''
						}
					],
					toIata: '',
					to: '',
					departDate: '2023-11-17',
					returnDate: '2024-01-06',
					fromMetro: false,
					toMetro: false
				}
			],
			cabin: 0,
			tripType: 1,
			passengers: {
				adults: 1,
				child: {
					count: 0,
					ages: []
				}
			}
		};

		this.searchBox = new SearchBox({
			id: 'abSearchBox',
			calendarRender: gebi('abSearchbox__dates'),
			selectedPassengersView: 'default',
			config: searchboxConfig,
			showresultMode: false,
			callbacks: {
				onPreviewReceived: (instance, previewGroup) => {
					if (urlVars?.filter) {
						instance.showresultURL = setUrlParameter(instance.showresultURL, 'filter', urlVars.filter);
					}
					if (previewGroup?.flights?.length) {
						instance.cancelSearch();
						location.href = instance.showresultURL;
					}
				},
				onSearchComplete: (instance) => {
					if (instance.data.forceNearbyDates) {
						instance.showresultURL = setUrlParameter(instance.showresultURL, 'forceNearbyDates', 1);
					}

					if (urlVars?.filter) {
						instance.showresultURL = setUrlParameter(instance.showresultURL, 'filter', urlVars.filter);
					}
					location.href = instance.showresultURL;
				}
			}
		});
	},

	/**
	 * Copied from showresult
	 */
	showSearchBoxExtended () {
		const scrollY = window.scrollY;
		this.searchBoxWrapper.classList.add('abShowResultSearchBox--visible');

		document.body.classList.add('no-scroll');

		this.searchBox.html.classList.add('abSearchBox--extended');
		this.calendarRender?.hide();

		if (document.body.style.position !== 'fixed') {
			document.body.style.position = 'fixed';
			document.body.style.top = `-${scrollY}px`;
		}
	},

	/**
	 * @param {Number} timeout
	 */
	hideSearchBoxExtended (timeout = 0) {
		const inner = this.searchBoxWrapper.querySelector('.abShowResultSearchBox__inner');
		inner.classList.remove('abShowResultSearchBox__inner--touch');
		inner.classList.add('abShowResultSearchBox__inner--slideUp');

		setTimeout(() => {
			const scrollY = document.body.style.top;
			this.searchBoxWrapper.classList.remove('abShowResultSearchBox--visible');
			document.body.classList.remove('no-scroll');
			inner.classList.remove('abShowResultSearchBox__inner--slideUp');
			// Reset scroll position
			document.body.style.position = '';
			document.body.style.top = '';
			window.scrollTo(0, parseInt(scrollY || '0') * -1);
		}, timeout);

		// tablet / desktop
		this.searchBox.html.classList.remove('abSearchBox--extended');
	}
};

documentReady(function () {
	window.favorite = favoritePage;
	favoritePage.init();
});
